import mainConfig from "common/config/main.config";
import request from "common/requests/request";
import serviceResultFactory from "common/requests/serviceResultFactory";

const getCountryList = (locale = "en-GB") => {
  const baseApiUrl = mainConfig.getConfig(process.env.REACT_APP_ENVIRONMENT).baseApiUrl;
  const query = `
    query {
      formDefinitionCountry(locale: "${locale}") {
        code
        name
      }
    }
  `;

  return request
    .graphqlRequest(`${baseApiUrl}/graphql`, query)
    .then(serviceResultFactory.fromGraphqlResponse)
    .catch(serviceResultFactory.fromGraphqlError);
};

const getCountryRegionsList = (countryCode: string) => {
  const baseApiUrl = mainConfig.getConfig(process.env.REACT_APP_ENVIRONMENT).baseMagentoApiUrl;
  const query = `
    query {
      country(id: "${countryCode}") {
        id
        full_name_english
        available_regions {
          id
          code
          name
        }
      }
    }
  `;

  return request
    .graphqlRequest(`${baseApiUrl}/graphql`, query)
    .then(serviceResultFactory.fromGraphqlResponse)
    .catch(serviceResultFactory.fromGraphqlError);
};

const CountryService = {
  getCountryList,
  getCountryRegionsList
};

export default CountryService;
